import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { MButton } from '../../atoms/MButton';

import { getActionButtonWidth } from '../../helpers/style';

import { StyledPopupOfferActionButtonsCon } from './skins';
import IconShoppingCart from '../../atoms/IconShoppingCart';
import CircularProgress from '../../atoms/CircularProgress';

const PopupOfferActionButtons = forwardRef((props, ref) => {
  const {
    layout = 'horizontal',
    showShoppingCartIcon,
    onPrimaryClick,
    onSecondaryClick,
    showSkipButton = true,
    isActionsOrderReversed,
    isBottomBarButtonActionLoading,
    atcStatus,
  } = props;

  const isVerticalLayout = layout === 'vertical';

  const [
    bottomBarPrimaryButtonWidth,
    isButtonFullWidthClassByATC,
    isButtonWidthNotSet,
  ] = getActionButtonWidth(
    props.bottomBarPrimaryButtonWidth,
    props.bottomBarPrimaryButtonWidthStyle,
    isVerticalLayout,
    false,
  );

  const [
    bottomBarSecondaryButtonWidth,
    isSecondaryButtonFullWidthClassByATC,
    isSecondaryButtonWidthNotSet,
  ] = getActionButtonWidth(
    props.bottomBarSecondaryButtonWidth,
    props.bottomBarSecondaryButtonWidthStyle,
    isVerticalLayout,
    !showSkipButton,
  );

  const isHorizontalFullWidth =
    isButtonFullWidthClassByATC || isSecondaryButtonFullWidthClassByATC;

  let flexDirection = isVerticalLayout ? 'column' : 'row';
  if (isActionsOrderReversed) {
    flexDirection += '-reverse';
  }

  return (
    <StyledPopupOfferActionButtonsCon
      ref={ref}
      className={`mr-popup-offer-actions ${
        isHorizontalFullWidth
          ? 'mr-popup-offer-actions--horizontal-full-width'
          : ''
      }`}
      gap="8px"
      flexDir={flexDirection}
      flexWrap="wrap"
    >
      {showSkipButton && (
        <MButton
          onClick={onSecondaryClick}
          className={`mr-popup-offer-actions__skip-button ${
            !isSecondaryButtonWidthNotSet
              ? 'mr-popup-offer-actions--absolute-width'
              : ''
          }`}
          buttonStyle={props.bottomBarSecondaryButtonStyle}
          backgroundColor={props.bottomBarSecondaryButtonBackgroundColor}
          borderColor={props.bottomBarSecondaryButtonBorderColor}
          borderRadius={props.bottomBarSecondaryButtonBorderRadius}
          textColor={props.bottomBarSecondaryButtonTextColor}
          fontSize={props.bottomBarSecondaryButtonFontSize}
          mobileFontSize={props.bottomBarSecondaryButtonMobileFontSize}
          fontStyle={props.bottomBarSecondaryButtonFontStyle}
          fontWeight={props.bottomBarSecondaryButtonFontWeight}
          textDecoration={props.bottomBarSecondaryButtonTextDecoration}
          textAlignment={props.bottomBarSecondaryButtonTextAlignment}
          fontFamily={props.bottomBarSecondaryButtonFontFamily}
          padding={props.bottomBarSecondaryButtonPadding}
          margin={props.bottomBarSecondaryButtonMargin}
          height={props.bottomBarSecondaryButtonHeight}
          width={bottomBarSecondaryButtonWidth}
          disabled={atcStatus === 'adding'}
        >
          {props.bottomBarSecondaryButtonText}
        </MButton>
      )}
      <MButton
        onClick={onPrimaryClick}
        className={`mr-popup-offer-actions__checkout-button ${
          !isButtonWidthNotSet ? 'mr-popup-offer-actions--absolute-width' : ''
        }`}
        buttonStyle={props.bottomBarPrimaryButtonStyle}
        backgroundColor={props.bottomBarPrimaryButtonBackgroundColor}
        borderColor={props.bottomBarPrimaryButtonBorderColor}
        borderRadius={props.bottomBarPrimaryButtonBorderRadius}
        textColor={props.bottomBarPrimaryButtonTextColor}
        fontSize={props.bottomBarPrimaryButtonFontSize}
        mobileFontSize={props.bottomBarPrimaryButtonMobileFontSize}
        fontStyle={props.bottomBarPrimaryButtonFontStyle}
        fontWeight={props.bottomBarPrimaryButtonFontWeight}
        textDecoration={props.bottomBarPrimaryButtonTextDecoration}
        textAlignment={props.bottomBarPrimaryButtonTextAlignment}
        fontFamily={props.bottomBarPrimaryButtonFontFamily}
        padding={props.bottomBarPrimaryButtonPadding}
        margin={props.bottomBarPrimaryButtonMargin}
        height={props.bottomBarPrimaryButtonHeight}
        width={bottomBarPrimaryButtonWidth}
        disabled={atcStatus === 'adding'}
        gap="8px"
      >
        {isBottomBarButtonActionLoading ? (
          <CircularProgress
            fontSize={props.bottomBarPrimaryButtonFontSize}
            mobileFontSize={props.bottomBarPrimaryButtonMobileFontSize}
            color={props.bottomBarPrimaryButtonTextColor}
          />
        ) : (
          <>
            {showShoppingCartIcon && (
              <IconShoppingCart
                fontSize={props.bottomBarPrimaryButtonFontSize}
                mobileFontSize={props.bottomBarPrimaryButtonMobileFontSize}
                color={props.bottomBarPrimaryButtonTextColor}
              />
            )}
            {props.bottomBarPrimaryButtonText}
          </>
        )}
      </MButton>
    </StyledPopupOfferActionButtonsCon>
  );
});

PopupOfferActionButtons.propTypes = {
  bottomBarPrimaryButtonText: PropTypes.string.isRequired,
  bottomBarPrimaryButtonTextColor: PropTypes.string.isRequired,
  bottomBarPrimaryButtonStyle: PropTypes.string.isRequired,
  bottomBarPrimaryButtonBackgroundColor: PropTypes.string.isRequired,
  bottomBarPrimaryButtonBorderColor: PropTypes.string.isRequired,
  bottomBarPrimaryButtonBorderRadius: PropTypes.string.isRequired,
  bottomBarPrimaryButtonFontSize: PropTypes.string.isRequired,
  bottomBarPrimaryButtonMobileFontSize: PropTypes.string.isRequired,
  bottomBarPrimaryButtonFontStyle: PropTypes.string.isRequired,
  bottomBarPrimaryButtonFontWeight: PropTypes.string.isRequired,
  bottomBarPrimaryButtonTextDecoration: PropTypes.string.isRequired,
  bottomBarPrimaryButtonTextAlignment: PropTypes.string.isRequired,
  bottomBarPrimaryButtonFontFamily: PropTypes.string.isRequired,
  bottomBarPrimaryButtonPadding: PropTypes.string.isRequired,
  bottomBarPrimaryButtonMargin: PropTypes.string.isRequired,
  bottomBarPrimaryButtonHeight: PropTypes.string.isRequired,
  bottomBarPrimaryButtonWidth: PropTypes.string.isRequired,
  bottomBarPrimaryButtonWidthStyle: PropTypes.string.isRequired,
  atcStatus: PropTypes.string.isRequired,
  bottomBarSecondaryButtonText: PropTypes.string.isRequired,
  bottomBarSecondaryButtonTextColor: PropTypes.string.isRequired,
  bottomBarSecondaryButtonStyle: PropTypes.string.isRequired,
  bottomBarSecondaryButtonBackgroundColor: PropTypes.string.isRequired,
  bottomBarSecondaryButtonBorderColor: PropTypes.string.isRequired,
  bottomBarSecondaryButtonBorderRadius: PropTypes.string.isRequired,
  bottomBarSecondaryButtonFontSize: PropTypes.string.isRequired,
  bottomBarSecondaryButtonMobileFontSize: PropTypes.string.isRequired,
  bottomBarSecondaryButtonFontStyle: PropTypes.string.isRequired,
  bottomBarSecondaryButtonFontWeight: PropTypes.string.isRequired,
  bottomBarSecondaryButtonTextDecoration: PropTypes.string.isRequired,
  bottomBarSecondaryButtonTextAlignment: PropTypes.string.isRequired,
  bottomBarSecondaryButtonFontFamily: PropTypes.string.isRequired,
  bottomBarSecondaryButtonPadding: PropTypes.string.isRequired,
  bottomBarSecondaryButtonMargin: PropTypes.string.isRequired,
  bottomBarSecondaryButtonHeight: PropTypes.string.isRequired,
  bottomBarSecondaryButtonWidth: PropTypes.string.isRequired,
  bottomBarSecondaryButtonWidthStyle: PropTypes.string.isRequired,
  showShoppingCartIcon: PropTypes.bool.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func.isRequired,
  showSkipButton: PropTypes.bool.isRequired,
  isActionsOrderReversed: PropTypes.bool.isRequired,
  isBottomBarButtonActionLoading: PropTypes.bool.isRequired,
  layout: PropTypes.string.isRequired,
};

export default PopupOfferActionButtons;
